import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

interface SelectedSessionPayload {
  id: string;
  name: string;
}

interface UpdateSelectedSessionParams {
  selectedSession: SelectedSessionPayload | null;
}

const updateSelectedSessionAPI = async (params: UpdateSelectedSessionParams) => {
  const response = await baseAPI.patch<{
    selectedSession: SelectedSessionPayload | null;
  }>('/users/selected-session', params);
  return response.data;
};

export const useUpdateSelectedSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSelectedSessionAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.CURRENT_USER(),
      });
    },
  });
};
